import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch } from "../../../../store";
import { updateRoleContext } from "../../../../store/interviewHostSlice";
import styles from "./candidates.module.scss";

interface RoleContextModalProps {
  open: boolean;
  onClose: () => void;
  jobId: string;
  currentContext: string;
}

const RoleContextModal: React.FC<RoleContextModalProps> = ({
  open,
  onClose,
  jobId,
  currentContext,
}) => {
  const dispatch = useAppDispatch();
  const [context, setContext] = useState(currentContext);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await dispatch(updateRoleContext({ jobId, roleContext: context })).unwrap();
      onClose();
    } catch (error) {
      console.error("Failed to update role context:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Edit Role Context</h2>
          <button className={styles.modalClose} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.modalBody}>
          <label className={styles.formLabel}>
            Role Context
            <textarea
              className={styles.formTextarea}
              value={context}
              onChange={(e) => setContext(e.target.value)}
              rows={6}
              placeholder="Enter role context..."
            />
          </label>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.btnSecondary} onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button
            className={styles.btnPrimary}
            onClick={handleSave}
            disabled={saving || context.trim() === ""}
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default RoleContextModal;
